function CardProfile(name, email, imageUrl) {
  const cardContent = `
        <div class="card-profile__content">
            <h4 class="card-profile__heading">${name}</h4>
            <p class="card-profile__paragraph">
                <span class="card-profile__content-right-title">
                    ${email}
                </span>
            </p>
        </div>
    `;

  const imageContent = `
        <div class="card-profile__image">
            <picture class="image">
                <img class="image" src="${imageUrl}" alt="${name}">
            </picture>
        </div>
    `;

  const card = `
        <div class="card-profile">
            ${imageContent}
            ${cardContent}
        </div>
    `;

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = card;
  return tempDiv.firstElementChild;
}

export default CardProfile;
